import { Component, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Helper } from '../../core/services/helper';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  private readonly helperService = inject(Helper);

  footer = environment.FooterConfig;
  contact: any = environment.ContactConfig;

  quickLinks: any[] = [];
  contactItems: { icon: string; label: string; value?: string }[] = [];

  constructor() {
    this.quickLinks = this.helperService.getNavItems();

    if(this.contact.email) {
      this.contactItems.push({
        icon: this.contact.email.icon,
        label: this.contact.email.emailAddress,
        value: this.contact.email.emailLink
      });
    }

    if(this.contact.address) {
      this.contactItems.push({
        icon: this.contact.address.icon,
        label: this.contact.address.addressLines.join(', '),
        value: this.contact.address.mapUrl
      });
    }

    if(this.contact.phones && this.contact.phones.length > 0) {
      this.contactItems.push(...(this.contact.phones as any[]).map((phone) => {
        return {
          icon: phone.icon,
          label: phone.label + ': ' + phone.number,
        };
      }));
    }

  }
}
